import React, {
  useEffect,
  useMemo,
  useState,
} from "react";

import {
  Table,
} from "react-bootstrap";

import {
  getCamiones,
  deleteCamion,
  getCamionById,
} from "../helpers/rutaCamiones";

import ModalCamion from "./ModalCamion";
import "../css/tableclientes.css";

const TableCamiones = () => {
  const [camiones, setCamiones] =
    useState([]);

  const [loading, setLoading] =
    useState(true);

  const [camion, setCamion] =
    useState({});

  const [show, setShow] =
    useState(false);

  const [buscar, setBuscar] =
    useState("");

  const [tipo, setTipo] =
    useState("");

  /* ======================================================
     CONSULTA
  ====================================================== */

  const consultaCamiones = async () => {
    setLoading(true);

    const datos =
      await getCamiones();

    if (datos?.ok) {
      setCamiones(
        datos.camiones || []
      );
    } else {
      console.error(
        "❌ Error vehículos:",
        datos?.error
      );

      setCamiones([]);
    }

    setLoading(false);
  };

  useEffect(() => {
    consultaCamiones();
  }, []);

  /* ======================================================
     MODIFICAR
  ====================================================== */

  const modificaCamion = async (
    id
  ) => {
    const resp =
      await getCamionById(id);

    if (resp?.ok) {
      setCamion(resp.camion);
      setShow(true);

      return;
    }

    alert(
      typeof resp?.error === "string"
        ? resp.error
        : "No se pudo obtener el vehículo."
    );
  };

  const handleClose = () => {
    setShow(false);
    setCamion({});
    consultaCamiones();
  };

  /* ======================================================
     BAJA
  ====================================================== */

  const eliminarCamion = async (
    id
  ) => {
    const confirmar =
      window.confirm(
        "¿Está seguro que desea dar de baja este vehículo?"
      );

    if (!confirmar) {
      return;
    }

    const resp =
      await deleteCamion(id);

    if (!resp?.ok) {
      alert(
        typeof resp?.error === "string"
          ? resp.error
          : "No se pudo dar de baja el vehículo."
      );

      return;
    }

    consultaCamiones();
  };

  /* ======================================================
     COMPLETITUD

     Esto nos sirve mucho ahora:
     rápidamente vemos qué unidades
     necesitan actualización.
  ====================================================== */

  const estaCompleto = (
    vehiculo
  ) => {
    return Boolean(
      vehiculo?.patente &&
        vehiculo?.tipoUnidad &&
        vehiculo?.camion &&
        vehiculo?.marca &&
        vehiculo?.modelo &&
        vehiculo?.titular &&
        vehiculo?.cuitTitular
    );
  };

  /* ======================================================
     FILTROS
  ====================================================== */

  const camionesFiltrados =
    useMemo(() => {
      const texto =
        buscar
          .trim()
          .toLowerCase();

      return camiones.filter(
        (item) => {
          if (
            tipo &&
            item.tipoUnidad !== tipo
          ) {
            return false;
          }

          if (!texto) {
            return true;
          }

          const contenido = [
            item.codcam,
            item.camion,
            item.patente,
            item.tipoUnidad,
            item.marca,
            item.modelo,
            item.titular,
          ]
            .filter(Boolean)
            .join(" ")
            .toLowerCase();

          return contenido.includes(
            texto
          );
        }
      );
    }, [
      camiones,
      buscar,
      tipo,
    ]);

  const completos =
    useMemo(
      () =>
        camiones.filter(
          estaCompleto
        ).length,
      [camiones]
    );

  const pendientes =
    camiones.length -
    completos;

  /* ======================================================
     ETIQUETA TIPO
  ====================================================== */

  const nombreTipo = (
    valor
  ) => {
    const nombres = {
      CAMION: "Camión",
      CAMIONETA: "Camioneta",
      AUTO: "Auto",
      ACOPLADO: "Acoplado",
      SEMIRREMOLQUE:
        "Semirremolque",
      UTILITARIO:
        "Utilitario",
      OTRO: "Otro",
    };

    return (
      nombres[valor] ||
      valor ||
      "Camión"
    );
  };

  /* ======================================================
     RENDER
  ====================================================== */

  return (
    <div className="container-fluid mt-3">

      {/* RESUMEN */}

      <div className="row mb-3">
        <div className="col-md-4 mb-2">
          <div className="card shadow-sm">
            <div className="card-body py-3">
              <small className="text-muted">
                Vehículos activos
              </small>

              <h3 className="mb-0">
                {camiones.length}
              </h3>
            </div>
          </div>
        </div>

        <div className="col-md-4 mb-2">
          <div className="card shadow-sm">
            <div className="card-body py-3">
              <small className="text-muted">
                Datos completos
              </small>

              <h3 className="mb-0 text-success">
                {completos}
              </h3>
            </div>
          </div>
        </div>

        <div className="col-md-4 mb-2">
          <div className="card shadow-sm">
            <div className="card-body py-3">
              <small className="text-muted">
                Pendientes de completar
              </small>

              <h3 className="mb-0 text-warning">
                {pendientes}
              </h3>
            </div>
          </div>
        </div>
      </div>

      {/* FILTROS */}

      <div className="card shadow-sm mb-3">
        <div className="card-body">
          <div className="form-row">
            <div className="col-md-8 mb-2">
              <input
                className="form-control"
                placeholder="Buscar por patente, descripción, marca, modelo o titular..."
                value={buscar}
                onChange={(e) =>
                  setBuscar(
                    e.target.value
                  )
                }
              />
            </div>

            <div className="col-md-4 mb-2">
              <select
                className="form-control"
                value={tipo}
                onChange={(e) =>
                  setTipo(
                    e.target.value
                  )
                }
              >
                <option value="">
                  Todos los tipos
                </option>

                <option value="CAMION">
                  Camiones
                </option>

                <option value="CAMIONETA">
                  Camionetas
                </option>

                <option value="AUTO">
                  Autos
                </option>

                <option value="ACOPLADO">
                  Acoplados
                </option>

                <option value="SEMIRREMOLQUE">
                  Semirremolques
                </option>

                <option value="UTILITARIO">
                  Utilitarios
                </option>

                <option value="OTRO">
                  Otros
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>

      {/* TABLA */}

      <div className="card shadow-sm">
        <div className="card-header bg-white">
          <div className="d-flex justify-content-between align-items-center">
            <div>
              <h5 className="mb-0">
                Flota de vehículos
              </h5>

              <small className="text-muted">
                {camionesFiltrados.length} unidades
              </small>
            </div>
          </div>
        </div>

        <div className="card-body p-0">
          {loading ? (
            <div className="p-4 text-center">
              Cargando vehículos...
            </div>
          ) : (
            <Table
              responsive
              hover
              className="mb-0"
            >
              <thead
                style={{
                  background:
                    "#f5f6f8",
                }}
              >
                <tr>
                  <th
                    style={{
                      width: 110,
                    }}
                  >
                    Acciones
                  </th>

                  <th>N.º</th>

                  <th>Patente</th>

                  <th>Tipo</th>

                  <th>
                    Descripción
                  </th>

                  <th>
                    Marca / Modelo
                  </th>

                  <th>Titular</th>

                  <th className="text-center">
                    TelePASE
                  </th>

                  <th className="text-center">
                    Telepeaje+
                  </th>

                  <th className="text-center">
                    Datos
                  </th>
                </tr>
              </thead>

              <tbody>
                {camionesFiltrados.map(
                  (item) => (
                    <tr
                      key={item._id}
                    >
                      <td>
                        <button
                          className="btn btn-primary btn-sm mr-2"
                          title="Modificar"
                          onClick={() =>
                            modificaCamion(
                              item._id
                            )
                          }
                        >
                          <i
                            className="fa fa-pencil-square-o"
                            aria-hidden="true"
                          />
                        </button>

                        <button
                          className="btn btn-danger btn-sm"
                          title="Dar de baja"
                          onClick={() =>
                            eliminarCamion(
                              item._id
                            )
                          }
                        >
                          <i
                            className="fa fa-trash-o"
                            aria-hidden="true"
                          />
                        </button>
                      </td>

                      <td>
                        {item.codcam}
                      </td>

                      <td>
                        <strong>
                          {item.patente}
                        </strong>
                      </td>

                      <td>
                        {nombreTipo(
                          item.tipoUnidad
                        )}
                      </td>

                      <td>
                        {item.camion ||
                          "-"}
                      </td>

                      <td>
                        {[
                          item.marca,
                          item.modelo,
                        ]
                          .filter(
                            Boolean
                          )
                          .join(" ") ||
                          "-"}
                      </td>

                      <td>
                        {item.titular ||
                          "-"}
                      </td>

                      <td className="text-center">
                        {item.peajes
                          ?.telepase
                          ?.activo ? (
                          <span className="badge badge-success">
                            Activo
                          </span>
                        ) : (
                          <span className="badge badge-light">
                            No
                          </span>
                        )}
                      </td>

                      <td className="text-center">
                        {item.peajes
                          ?.telepeajePlus
                          ?.activo ? (
                          <span className="badge badge-success">
                            Activo
                          </span>
                        ) : (
                          <span className="badge badge-light">
                            No
                          </span>
                        )}
                      </td>

                      <td className="text-center">
                        {estaCompleto(
                          item
                        ) ? (
                          <span className="badge badge-success">
                            Completo
                          </span>
                        ) : (
                          <span className="badge badge-warning">
                            Completar
                          </span>
                        )}
                      </td>
                    </tr>
                  )
                )}

                {!camionesFiltrados.length && (
                  <tr>
                    <td
                      colSpan="10"
                      className="text-center py-4"
                    >
                      No se encontraron
                      vehículos.
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          )}
        </div>
      </div>

      <ModalCamion
        show={show}
        handleClose={
          handleClose
        }
        camion={camion}
      />
    </div>
  );
};

export default TableCamiones;